import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';
import WaitlistSignUpForm from '../forms/WaitlistSignUpForm';

interface WaitlistSignUpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function WaitlistSignUpModal({ isOpen, onClose }: WaitlistSignUpModalProps) {
  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-lg w-full rounded-2xl bg-white p-8">
          <div className="flex justify-between items-start mb-6">
            <div>
              <Dialog.Title className="text-2xl font-bold">
                Join the VBC Venture Waitlist
              </Dialog.Title>
              <Dialog.Description className="text-gray-600 mt-2">
                Be among the first to experience our revolutionary business learning path.
              </Dialog.Description>
            </div>
            <button 
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          <WaitlistSignUpForm onSuccess={onClose} />
        </Dialog.Panel>
      </div>
    </Dialog>
  );
} 